import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/rootReducer';
import { sendUserDetailsToSW } from '@/serviceworker/mediator';
import { toSentryUser } from '@/config/sentry';

/**
 * Syncs authenticated user identity to Sentry for errors and Session Replay.
 * Clears identity on logout so shared tablets do not misattribute events.
 *
 * If replays still show Anonymous for pre-login segments, inspect `/envelope/`
 * requests in DevTools — later segments after login should include `user`.
 */
export function useSentryUser() {
  const user = useSelector((state: RootState) => state.auth.user);

  useEffect(() => {
    if (user?.id) {
      Sentry.setUser(toSentryUser(user));
      sendUserDetailsToSW();
      return;
    }
    Sentry.setUser(null);
  }, [user]);
}
